import React, { useContext } from "react";

import styles from "./SkipButton.module.scss";
import block from 'bem-css-modules';

import { AppContext } from "../../../../util/context";
import { sanitizeContent as s } from "../../../../util/functions";

const SkipButton = (props: { skipBtnText: string, nextStep: string, stepLabel: string }) => {
  const context = useContext(AppContext);
  const { handleStepTransition } = context;
  const {
    skipBtnText,
    nextStep,
    stepLabel,
  } = props;

  const b = block(styles);

  const handleOnSkip = () => {
    const stepData = {
      label: stepLabel,
      settings: {
        next_step: nextStep,
        last_step: null,
        tracking: {
          gtmEvent: ""
        }
      }
    }

    handleStepTransition(context, stepData);
  }

  return (
    <div className={b()}>
      <button onClick={handleOnSkip} className={`${b("button")} event-tracking-step--${stepLabel}-skip`} >
        <span dangerouslySetInnerHTML={{ __html: s(skipBtnText) }} />
      </button>
    </div>
  )
}

export default SkipButton;